import React, {useState, useEffect} from 'react';
import Select from 'react-select';
import styled from 'styled-components';
import { connect } from 'react-redux';
import AccionesService from '@app/services/acciones.service';

const Styles = styled.div``;

const SelectAcciones = ({
    id,
    value,
    onChange,
    isInvalid,
    isClearable,
    disabled,
    stack,
    ...defaultProps
}) => {
    const [items, setItems] = useState([]);
    const [options, setOptions] = useState([]);
    const [selectedValue, setSelectedValue] = useState();

    const onSelectValue = (ev) => {
        setSelectedValue(ev);
        if(Array.isArray(ev)){
            onChange(ev.map(e=>{
                const item = items.find(it=>it.id_ac === e.value);
                return {
                    ...e,
                    item: item,
                }
            }));
        } else if(ev){
            ev.item = items.find(it=>it.id_ac === ev.value);
            onChange(ev);
        } else {
            onChange(null);
        }
    };
    useEffect(() => {
        AccionesService.getAll().then((response) => {
            setItems(response);
        });
    }, []);
    useEffect(() => {
        const newOptions = items
            .map((item) => {
            return {
                value: item.id_ac,
                label: item.nombre_ac,
            };
        });
        setOptions(newOptions);
        if(Array.isArray(value)){
            setSelectedValue(value.map(va=>{
                const item = items.find(it=>it.id_ac === va);
                if(item){
                    return {
                        label:item.nombre_ac,
                        value:item.id_ac,
                    };  
                }
                return {
                    label:va.nombre_ac,
                    value:va.id_ac,
                };
                
            }))
        }
    }, [items]);

    const conditionalProps = {}
    if(stack && stack.length === 0){
        conditionalProps.menuPortalTarget = document.body;
    }
    return (
        <Styles>
            <Select
                {...defaultProps}
                isDisabled={disabled}
                inputId={id}
                name={id}
                className={`react-select-container ${
                    isInvalid ? 'is-invalid' : ''
                }`}
                noOptionsMessage={()=>"Sin opciones"}
                classNamePrefix="react-select"
                placeholder="Seleccione..."
                options={options}
                value={selectedValue}
                onChange={onSelectValue}
                isClearable={isClearable}
            />
        </Styles>
    );
};

SelectAcciones.defaultProps = {
    isClearable: false,
    onChange: () => {},
};

const mapStateToProps = (state) => ({
    stack: state.modalProvider.stack,
})

const mapDispatchToProps = {}
export default connect(mapStateToProps, mapDispatchToProps)(SelectAcciones)

